import { useState } from "react"
import { Button } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { DeleteDialog } from "./DeleteDialog"

const useStyles = makeStyles()((theme) => ({
  button: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
  },
}))

const DeleteDialogButton = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const {
    classes: { button },
  } = useStyles()

  const handleClick = () => {
    setIsDialogOpen(true)
  }

  const handleClose = () => {
    setIsDialogOpen(false)
  }

  return (
    <>
      <Button className={button} variant="contained" onClick={handleClick}>
        Delete
      </Button>
      <DeleteDialog open={isDialogOpen} onClose={handleClose} />
    </>
  )
}

export { DeleteDialogButton }
